import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font } from '~styles/theme.stylex';
export const styles = {
  tile: {
    position: "x1n2onr6",
    flexShrink: "x2lah0s",
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    fontWeight: "x1sl8krj",
    backgroundColor: "x4aap8p",
    $$css: true
  },
  hidden: {
    color: "xarw3lm",
    $$css: true
  },
  initials: {
    userSelect: "x87ps6o",
    $$css: true
  },
  img: {
    position: "x10l6tqk",
    inset: "x10a8y8t",
    insetInline: null,
    insetInlineStart: null,
    insetInlineEnd: null,
    left: null,
    right: null,
    insetBlock: null,
    top: null,
    bottom: null,
    width: "xh8yej3",
    height: "x5yr21d",
    objectFit: "xl1xv1r",
    $$css: true
  }
};